<div class="row">
  <div class="col-md-12 p-0">
    <nav *ngIf="modules">
      <!-- <h2 class="text-center">IHS</h2> -->
      <ul class="sidebar-nav">
        <li *ngFor="let module of modules" class="sidebar-option">
          <a [ngClass]="{ active: checkActiveRoute(module.identifier) }"
            routerLink="{{ module.routeLink }}">{{ module.modulename }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>